import { configureStore } from '@reduxjs/toolkit';
import protocolReducer from '../slices/protocolSlice';
import uiReducer from '../slices/uiSlice';
import userReducer from '../slices/userSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    protocols: protocolReducer,
    ui: uiReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['protocols/setProtocols', 'protocols/addProtocols'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
